module.exports = __webpack_public_path__ + "static/media/logo-galeno.70f05834.png";